import React, { useState, useEffect } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { uniqueWords, convertGenderText } from '../utils/consts';
import {
    Box,
    Typography,
    FormControl,
    FormLabel,
    FormGroup,
    FormControlLabel,
    Checkbox,
    // FormHelperText,
    Button,
    TextField,
    // Stepper,
    // Step,
    // StepLabel,
    List,
    ListItem,
    ListItemText
} from '@mui/material';

const ValuesSection = ({ onNext, formData }) => {
    const [step, setStep] = useState(0);
    const [selectedValues, setSelectedValues] = useState([]);
    const [eliminatedValues, setEliminatedValues] = useState([]);
    const [valuesList, setValuesList] = useState([]);
    const { control, handleSubmit } = useForm({
        defaultValues: {
            wartosci_dodatkowe_mysli: ''
        }
    });

    useEffect(() => {
        fetch('/assets/lista_wartosci.txt')
            .then(response => response.text())
            .then(text => {
                const values = text.split('\n').filter(value => value.trim());
                setValuesList(values);
            })
            .catch(error => {
                console.error('Error loading values list:', error);
                // Fallback to hardcoded values if file loading fails
                setValuesList(uniqueWords);
            });
    }, []);
    const text = `Gdybyś ${convertGenderText('musiał/a', formData.zwrot_plec)} zrezygnować z jednej z wartości, które zostały zaznaczone, to która by to była?`
    const textRepeate = `Gdybyś musiał znów zrezygnować z jednej z wartości które zostały zaznaczone, która by to była?`
    const eliminationQuestions = [
        text,
        textRepeate,
        textRepeate,
        textRepeate,
        textRepeate,
        textRepeate,
        textRepeate,
        textRepeate,
        textRepeate,
        textRepeate,
        textRepeate,
        textRepeate,
        textRepeate,
        textRepeate,
        textRepeate,
    ];

    const handleValueSelection = (value) => {
        if (selectedValues.includes(value)) {
            setSelectedValues(selectedValues.filter(v => v !== value));
        } else if (selectedValues.length < 10) {
            setSelectedValues([...selectedValues, value]);
        }
    };

    const handleValueElimination = (value) => {
        if (eliminatedValues.length < 9) {
            setEliminatedValues([...eliminatedValues, value]);
            setSelectedValues(selectedValues.filter(v => v !== value));
        }
    };

    const handleFinalSubmit = (data) => {
        const finalData = {
            wartosci_wybrane_poczatek: eliminatedValues,
            hierarchia_wartosci: selectedValues.filter(v => !eliminatedValues.includes(v)),
            ...data
        };
        onNext(finalData);
    };

    const renderStep = () => {
        switch (step) {
            case 0:
                return (
                    <>
                        <Typography variant="body1" color="blue" sx={{ mb: 3 }} component="div">
                            <b>Co to są wartości?</b>
                            <br />
                            Wartości to indywidualne przekonania o tym, co jest ważne, cenne i warte zabiegania o nie. Są kształtowane przez doświadczenia, kulturę, wychowanie i system wartości. Mają swój względnie stały trzon, jednak w ciągu życia mogą się zmieniać ze względu na etap w którym się znajdujemy.
                            <br />
                            <b>Rodzaje wartości</b>
                            <br />
                            Wartości można podzielić na kategorie:
                            <ul>
                                <li><b>Wartości fizyczne:</b> Wartości związane z rzeczami materialnymi, takimi jak pieniądze, posiadanie, status.</li>
                                <li><b>Wartości mentalne:</b> Wartości związane z relacjami, doświadczeniami, rozwojem osobistym.</li>
                            </ul>
                            <br />
                            <b>Znaczenie świadomości wartości</b>
                            <br />
                            Świadomość wartości to umiejętność rozpoznawania i nazywania tego, co jest dla nas ważne. To kluczowy element rozwoju osobistego i budowania satysfakcjonujących relacji. Kiedy jesteśmy świadomi swoich wartości, możemy podejmować decyzje, które są zgodne z tym jak widzimy świat oraz samych siebie. Wartości, które będą nas prowadzić do poczucia szczęścia i spełnienia.
                        </Typography>
                        <FormControl component="fieldset" fullWidth sx={{ mb: 3 }}>
                            <FormLabel component="legend">
                                <Typography variant="h6" color="black">
                                    Wybierz 10 wartości, które są dla Ciebie najważniejsze:
                                </Typography>
                            </FormLabel>
                            <FormGroup
                                style={{
                                    'display': 'grid',
                                    'gridTemplateColumns': 'repeat(2, 1fr)'
                                }}>
                                {valuesList.map((value) => (
                                    <FormControlLabel
                                        key={value}
                                        control={
                                            <Checkbox
                                                checked={selectedValues.includes(value)}
                                                onChange={() => handleValueSelection(value)}
                                            />
                                        }
                                        label={value}
                                    />
                                ))}
                            </FormGroup>
                        </FormControl>
                        <Button
                            variant="contained"
                            color="primary"
                            fullWidth
                            disabled={selectedValues.length !== 10}
                            onClick={() => setStep(1)}
                        >
                            Dalej
                        </Button>
                    </>
                );
            case 1:
                return (
                    <Box component="form" onSubmit={handleSubmit(handleFinalSubmit)} >
                        <Typography variant="h6" color="black" gutterBottom>
                            {eliminationQuestions[eliminatedValues.length]}
                        </Typography>
                        <List >
                            {selectedValues.map((value) => (
                                <ListItem
                                    key={value}
                                    button
                                    onClick={() => handleValueElimination(value)}
                                >
                                    <ListItemText primary={value} />
                                </ListItem>
                            ))}
                        </List>
                        {selectedValues.length === 1 && (
                            <Button
                                type="submit"
                                variant="contained"
                                color="primary"
                                fullWidth
                            >
                                Dalej
                            </Button>
                        )}
                    </Box >
                );
            // case 2:
            //     return (
            //         <Box component="form" onSubmit={handleSubmit(handleFinalSubmit)}>
            //             <Typography variant="h6" gutterBottom>
            //                 Twoja najważniejsza wartość:
            //             </Typography>
            //             <Typography variant="body1" gutterBottom sx={{ mb: 3 }}>
            //                 {selectedValues[0]}
            //             </Typography>
            //             <Controller
            //                 name="wartosci_dodatkowe_mysli"
            //                 control={control}
            //                 render={({ field }) => (
            //                     <TextField
            //                         {...field}
            //                         fullWidth
            //                         multiline
            //                         rows={4}
            //                         label="Dodatkowe przemyślenia dotyczące Twoich wartości (opcjonalne)"
            //                         sx={{ mb: 3 }}
            //                     />
            //                 )}
            //             />
            // <Button
            //     type="submit"
            //     variant="contained"
            //     color="primary"
            //     fullWidth
            // >
            //     Dalej
            // </Button>
            //         </Box>
            //     );
            default:
                return null;
        }
    };

    return (
        <Box sx={{ mt: 3 }}>
            {/* <Stepper activeStep={step} sx={{ mb: 4 }}>
                <Step>
                    <StepLabel>Wybór wartości</StepLabel>
                </Step>
                <Step>
                    <StepLabel>Eliminacja</StepLabel>
                </Step>
                <Step>
                    <StepLabel>Podsumowanie</StepLabel>
                </Step>
            </Stepper> */}
            {renderStep()}
        </Box>
    );
};

export default ValuesSection; 